import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import PermissionsIndex from './Permissions'
import PermissionsSingle from './Permissions/single'
import ContentIndex from './content'
import CategoriesIndex from './categories'
import user from './user'
import modal from './modal/index'
import toast from "@/core/services/store/toast";
import menu from './menu'
import global from '@/core/services/store/global'
import wallet from '@/core/services/store/wallet'


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    PermissionsIndex,
    PermissionsSingle,
    CategoriesIndex,
    ContentIndex,
    config,
    breadcrumbs,
    profile,
    user,
    modal,
    toast,
    menu,
    global,
    wallet
  }
});
